module.exports = __webpack_public_path__ + "img/4.dd7d1aa9.png";